var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptimicitiTealClearLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "944.4 1401.4 165.72 166.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00928B",
    d: "M944.4,1483.46c0-22.9,7.91-42.26,23.73-58.08c15.82-15.97,35.18-23.96,58.08-23.96     c22.9,0,42.26,7.99,58.08,23.96c15.97,15.82,23.96,35.18,23.96,58.08c0,22.75-7.99,42.11-23.96,58.08     c-15.82,15.97-35.18,23.96-58.08,23.96c-22.9,0-42.26-7.98-58.08-23.96C952.31,1525.42,944.4,1506.06,944.4,1483.46z     M1087.23,1483.46c0-17.48-5.88-32.09-17.63-43.84c-11.45-11.9-25.92-17.85-43.39-17.85c-17.33,0-31.87,5.95-43.62,17.85     c-11.6,11.9-17.4,26.52-17.4,43.84c0,17.18,5.8,31.79,17.4,43.84c11.75,11.75,26.29,17.63,43.62,17.63     c17.48,0,31.94-5.88,43.39-17.63C1081.35,1515.25,1087.23,1500.64,1087.23,1483.46z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00928B",
    d: "M1026.4,1406.95c-41.7,0-75.5,33.8-75.5,75.5s33.8,75.5,75.5,75.5s75.5-33.8,75.5-75.5     S1068.1,1406.95,1026.4,1406.95z M1069.82,1501.21l-32.7-21.39l-53.83,35.43l-13.58-21.22l67.42-44.37l0.08,0.15l0.02-0.03     l45.87,30.01L1069.82,1501.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimicitiTealClearLogoOnly);
export default __webpack_public_path__ + "static/media/optimiciti_teal_clear_logo_only.b03f5d41f0ae656ac342b9ac1acada22.svg";
export { ForwardRef as ReactComponent };